<template>
    <div class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-t xs:tw-overflow-visible course-card-release-hero">
        <div class="tw-mb-2 tw-text-white course-card-release-hero-title" :class="{'tw-mt-2': course.theme === 'image'}">{{ $t('membership.available_in') }}:</div>
        <countdown variant="cards" :deadline="course.release_date" @countdownFinished="refreshPage()" class="countdown"></countdown>
        <div class="tw-relative tw-z-20 tw-flex tw-justify-center">
            <clickable-icon v-tooltip.bottom="$t('membership.set_reminder_explanation')" v-if="!course.is_released && $user" size="small-regular" bg_color="very-light" icon_animation="rotate-10-deg" @click.native="setReminderForReleaseDate" class="tw-my-2">
                <i class="fa fa-lg fa-bell tw-text-white bell"></i>
                <i v-if="reminders.length >= 1" class="fa fa-check overlapping-icon"></i>
            </clickable-icon>
        </div>
    </div>
</template>

<script>
    import Countdown from "../ui/Countdown";
    import Modal from "../../mixins/v2/Modal";
    import ReminderModal from "../ui/ReminderModal";
    import ReminderDropdown from "../ui/ReminderDropdown";
    import { EventBus } from "../../lib/event-bus";
    import Notification from "../../lib/models/Notification";

    export default {
        name: 'CourseCardReleaseHero',

        components: {
            'reminder-modal': ReminderModal,
            'reminder-dropdown': ReminderDropdown,
            'countdown': Countdown,
        },

        mixins: [Modal],

        data() {
            return {
                reminders: [],
            }
        },

        props: {
            course: {
                required: true,
            },

            deadline: {
              required: true,
            },
        },

        methods: {
            refreshPage() {
                this.$router.go();
            },

            setReminderForReleaseDate() {
                const release_date_reminder = {
                    duration: 1,
                    unit: 'minutes',
                    value: true,
                };

                if(this.reminders.length >= 1) {
                    Reminder.api().deleteAllReminders(this.course.id, 'product').then(() => {
                        this.getReminders();
                        EventBus.$emit('reminderChanged', this.course.id);
                        Notification.insert({
                            data:  [
                                {
                                    title: this.$t('membership.removed_reminder_notification'),
                                },
                            ]
                        });
                    })
                } else {
                    Reminder.api().store(this.course.id, 'product', [release_date_reminder]).then(() => {
                        this.getReminders();
                        EventBus.$emit('reminderChanged', this.course.id);
                        Notification.insert({
                            data: [
                                {
                                    title: this.$t('membership.added_reminder_notification'),
                                },
                            ]
                        });
                    });
                }
            },

            getReminders(){
                Reminder.api().fetchAllReminders(this.course.id, 'product').then((response) => {
                    this.reminders = response.response.data.data;
                });
            }
        },

        created() {
            this.getReminders();

            EventBus.$on('reminderChanged', (course_id) => {
                if(this.course.id === course_id) {
                    Reminder.api().fetchAllReminders(this.course.id, 'product').then((response) => {
                        this.reminders = response.response.data.data;
                    })
                }
            })
        },
    }
</script>

<style lang="scss" scoped>
    .course-card-release-hero-title {
        font-weight: 600;
    }

    .course-card-release-hero {
        background-color: rgba(0, 0, 0, 0.6);
    }

    .overlapping-icon {
        position: absolute;
        font-size: 9px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -52%);
        color: rgba(0, 0, 0, 0.6);
    }

    .bell {
        &:hover, &:focus, &:active {
            animation: shake .5s cubic-bezier(.35,.08,.18,.96) both;
        }
    }

    @keyframes shake {
        0% { transform: rotate(0); }
        15% { transform: rotate(5deg); }
        30% { transform: rotate(-5deg); }
        45% { transform: rotate(4deg); }
        60% { transform: rotate(-4deg); }
        75% { transform: rotate(2deg); }
        85% { transform: rotate(-2deg); }
        92% { transform: rotate(1deg); }
        100% { transform: rotate(0); }
    }
</style>
